import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import {NavLink} from "react-router-dom";
import Header from "../header/Header";

const Profile = () => {
    return (
        <div className="profile-wrapper">
            <Header/>
            <div className="profile-content">
                <div className="nav-profile">
                    <div className="icon-user d-flex justify-content-center align-items-center">
                        <div className="icon-box xp-6 position-relative">
                            <IconName name="face" className="icon"/>
                            <span className="add-button position-absolute">
                                    <IconName name="add" className="icon"/>
                                </span>
                        </div>
                    </div>
                    <nav className="nav-links">
                        <div className="swiper profile-swiper">
                            <ul className="swiper-wrapper nav nav-tabs" id="tab-profile" role="tablist">
                                <li className="nav-item swiper-slide" role="presentation">
                                    <NavLink exact to="/counter" className="nav-link">
                                        <IconName name="face" className="icon"/>
                                        پیشخوان
                                    </NavLink>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <NavLink to="/orders" className="nav-link">
                                        <IconName name="receipt" className="icon"/>
                                        سفارش ها
                                    </NavLink>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <NavLink to="/address" className="nav-link">
                                        <IconName name="add_location" className="icon"/>
                                        نشانی ها
                                    </NavLink>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <NavLink to="/commentsProfile" className="nav-link">
                                        <IconName name="comment" className="icon"/>
                                        نظرات
                                    </NavLink>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <NavLink to="/emailProfile" className="nav-link">
                                        <IconName name="add_location" className="icon"/>
                                        پیغام ها
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Profile;
